import React, { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import { Badge } from '../../../components/badge/badge.index';
import { Divider, Typography } from 'antd';
import CoinIcon from '../../../../utilities/components/coinIcon/coinIcon.index';
import { OrderTransaction, Transaction, OrderTransactionDetail, TransactionType } from '../../../../interfaces';
import {
    formatCardNumber,
    get,
    getOrderTransactionBadgeType,
    getTransactionBadgeType,
    getTransactionTypeBadgeType,
    priceDigit,
} from '../../../../scripts';
import moment from 'jalali-moment';
import { API } from 'data/30pay.api';

interface Props {
    item: Transaction;
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export const TransactionDetailModal: FC<Props> = ({ open, setOpen, item }) => {

    return (
        <div className={'grid grid-cols-2 gap-4'}>
            <div className={'flex items-center gap-2'}>
                <CoinIcon symbol={item.market?.symbol ?? ''} className={'w-8 h-8'} />
                <span className={'text-base font-bold'}>{item.market?.name ?? ''}</span>
                <span className={'en text-sm font-medium'}>{item.market?.symbol ?? ''}</span>
            </div>
            <Badge
                className="w-fit"
                type={getTransactionBadgeType(item.state?.id ?? -1) as 'success' | 'warning' | 'danger' | 'info'}
                title={item.state?.title ?? ''}
            />
            <div className={'flex flex-col'}>
                <Typography.Text className="font-bold text-gray-500">نوع تراکنش</Typography.Text>
                <Badge
                    noIcon
                    className="w-fit"
                    type={getTransactionTypeBadgeType(item.type?.id ?? -1) as 'success' | 'warning' | 'danger' | 'info'}
                    title={item.type?.title ?? ''}
                />
            </div>
            {item.trackingCode ? (
                <div className={'flex flex-col'}>
                    <Typography.Text className="font-bold text-gray-500">کد پیگیری</Typography.Text>
                    <Typography.Text className="en text-right" copyable>
                        {item.trackingCode}
                    </Typography.Text>
                </div>
            ) : null}
            {item.amount !== undefined ? (
                <div className={'flex flex-col'}>
                    <Typography.Text className="font-bold text-gray-500">مقدار</Typography.Text>
                    <Typography.Text>{item.amount?.toLocaleString()}</Typography.Text>
                </div>
            ) : null}
            {/* {item.balanceAfterTransaction ? (
                <div className={'flex flex-col'}>
                    <Typography.Text className="font-bold text-gray-500">موجودی پس از تراکنش</Typography.Text>
                    <Typography.Text>{priceDigit(item.balanceAfterTransaction)} تومان</Typography.Text>
                </div>
            ) : null} */}
            {item.createdAt ? (
                <div className="flex flex-col">
                    <Typography.Text className="font-bold text-gray-500">تاریخ ایجاد تراکنش</Typography.Text>
                    <Typography.Text>
                        {moment.utc(item.createdAt).locale('fa').local().format('jYYYY/jM/jD - HH:mm')}
                    </Typography.Text>
                </div>
            ) : null}

            {/* {item.network?.name ? (
                <div className="flex flex-col">
                    <Typography.Text className="font-bold text-gray-500">شبکه</Typography.Text>
                    <Typography.Text className="en text-right">{item.network.name}</Typography.Text>
                </div>
            ) : null}

            {item.network?.fee ? (
                <div className="flex flex-col">
                    <Typography.Text className="font-bold text-gray-500">کارمزد شبکه</Typography.Text>
                    <Typography.Text>
                        {priceDigit(item.network.fee)} {item.network.symbol}
                    </Typography.Text>
                </div>
            ) : null} */}

            {item.paymentIdentifier ? (
                <div className="flex flex-col">
                    <Typography.Text className="font-bold text-gray-500">شناسه پرداخت</Typography.Text>
                    <Typography.Text className="en">{item.paymentIdentifier}</Typography.Text>
                </div>
            ) : null}

            {/* {item.voucher?.batchNumber ? (
                <div className="flex flex-col">
                    <Typography.Text className="font-bold text-gray-500">بچ نامبر</Typography.Text>
                    <Typography.Text>{item.voucher.batchNumber}</Typography.Text>
                </div>
            ) : null} */}

            {/* {item.voucher?.voucherCode ? (
                <div className="flex flex-col">
                    <Typography.Text className="font-bold text-gray-500">کد ووچر</Typography.Text>
                    <Typography.Text>{item.voucher.voucherCode}</Typography.Text>
                </div>
            ) : null}

            {item.voucher?.voucerhActivationCode ? (
                <div className="flex flex-col">
                    <Typography.Text className="font-bold text-gray-500">کد فعال‌سازی ووچر</Typography.Text>
                    <Typography.Text>{item.voucher.voucerhActivationCode}</Typography.Text>
                </div>
            ) : null} */}

            {/* {item.txId ? (
                <div className="flex flex-col">
                    <Typography.Text className="font-bold text-gray-500">هش تراکنش</Typography.Text>
                    <Typography.Text copyable ellipsis className="en text-right">
                        {item.txId}
                    </Typography.Text>
                </div>
            ) : null} */}

            {/* {item.wallet?.walletAddress ? (
                <div className="flex flex-col">
                    <Typography.Text className="font-bold text-gray-500">آدرس کیف پول</Typography.Text>
                    <Typography.Text copyable ellipsis className="en text-right">
                        {item.wallet.walletAddress}
                    </Typography.Text>
                </div>
            ) : null}

            {item.wallet?.memo ? (
                <div className="flex flex-col">
                    <Typography.Text className="font-bold text-gray-500">ممو</Typography.Text>
                    <Typography.Text copyable ellipsis className="en text-right">
                        {item.wallet.memo}
                    </Typography.Text>
                </div>
            ) : null} */}

            {/* {item.onPrice !== undefined ? (
                <div className="flex flex-col">
                    <Typography.Text className="font-bold text-gray-500">قیمت لحظه‌ای</Typography.Text>
                    <Typography.Text>{item.onPrice.toLocaleString()} تومان</Typography.Text>
                </div>
            ) : null} */}

            {item.digitalReceipt ? (
                <div className="flex flex-col">
                    <Typography.Text className="font-bold text-gray-500">رسید دیجیتال</Typography.Text>
                    <Typography.Text>{item.digitalReceipt}</Typography.Text>
                </div>
            ) : null}

            {item.commission !== undefined ? (
                <div className="flex flex-col">
                    <Typography.Text className="font-bold text-gray-500">کارمزد</Typography.Text>
                    <Typography.Text>{priceDigit(item.commission)} تومان</Typography.Text>
                </div>
            ) : null}

            {item.bankAccount ? (
                <>
                    {item.bankAccount.bankName ? (
                        <div className={'flex flex-col'}>
                            <Typography.Text className="font-bold text-gray-500">نام بانک</Typography.Text>
                            <Typography.Text>{item.bankAccount.bankName}</Typography.Text>
                        </div>
                    ) : null}
                    {item.type.id === TransactionType.Deposit ? (
                        item.bankAccount.cardNumber ? (
                            <div className={'flex flex-col'}>
                                <Typography.Text className="font-bold text-gray-500">شماره کارت</Typography.Text>
                                <Typography.Text>{formatCardNumber(item.bankAccount.cardNumber)}</Typography.Text>
                            </div>
                        ) : null
                    ) : item.bankAccount.iBan ? (
                        <div className={'flex flex-col'}>
                            <Typography.Text className="font-bold text-gray-500">شماره شبا</Typography.Text>
                            <Typography.Text>{item.bankAccount.iBan}</Typography.Text>
                        </div>
                    ) : null}
                </>
            ) : null}
        </div>
    );
};
